// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { atletaOlympia as _atletaOlympia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the atletaOlympia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2340
 * Chain Name: Atleta Olympia
 * Default Block Explorer: https://blockscout.atleta.network
 * Default RPC URL: https://testnet-rpc.atleta.network:9944
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { atletaOlympia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: atletaOlympia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const atletaOlympia = createCommon({
	..._atletaOlympia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
